// extracted by mini-css-extract-plugin
export default {"confetti":"Celebration_confetti__d4FMf","confetti__piece":"Celebration_confetti__piece__P7xUM","makeItRain":"Celebration_makeItRain__u8pAI"};